<template>
  <div>
    <el-button type="primary" @click="openAddDialog">新增产品</el-button>

    <!-- 产品表格 -->
    <el-table :data="list" style="width: 100%; margin-top: 20px;">
  <el-table-column prop="id" label="ID" width="80"></el-table-column>
  <el-table-column prop="name" label="产品名称"></el-table-column>
  <el-table-column prop="field" label="领域"></el-table-column>
  <el-table-column prop="type" label="类型"></el-table-column>

  <el-table-column prop="summary" label="简介">
    <template slot-scope="scope">
      <span>
        {{ scope.row.summary.length > 50 ? scope.row.summary.slice(0, 50) + '...' : scope.row.summary }}
      </span>
    </template>
  </el-table-column>

  <el-table-column prop="description" label="详细描述">
    <template slot-scope="scope">
      <span>
        {{ scope.row.description.length > 50 ? scope.row.description.slice(0, 50) + '...' : scope.row.description }}
      </span>
    </template>
  </el-table-column>

  <el-table-column prop="image" label="产品图片">
    <template slot-scope="scope">
      <el-image
        :src="getFullImageUrl(scope.row.image)"
        style="width: 60px; height: 60px;"
        fit="cover"
      />
    </template>
  </el-table-column>

  <el-table-column label="操作" width="200">
    <template slot-scope="scope">
      <el-button size="small" @click="edit(scope.row)">编辑</el-button>
      <el-button size="small" type="danger" @click="remove(scope.row.id)">删除</el-button>
    </template>
  </el-table-column>
</el-table>

    <!-- 分页 -->
    <el-pagination
      style="margin-top: 20px; text-align: right;"
      background
      layout="prev, pager, next"
      :total="total"
      :page-size="pageSize"
      :current-page.sync="page"
      @current-change="loadProducts"
    >
    </el-pagination>

    <!-- 新增/编辑对话框 -->
    <el-dialog :visible.sync="showAddDialog" title="产品管理" width="600px">
      <el-form :model="form" label-width="80px">
        <el-form-item label="名称">
          <el-input v-model="form.name" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="领域">
          <el-input v-model="form.field" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-input v-model="form.type" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="简介">
          <el-input
            v-model="form.summary"
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 12 }"
            style="width: 100%;"
          ></el-input>
        </el-form-item>
        <el-form-item label="详细描述">
          <el-input
            v-model="form.description"
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 12 }"
            style="width: 100%;"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片">
          <input type="file" @change="onFileChange" />
          <div v-if="form.imagePreview" style="margin-top:10px;">
            <el-image :src="form.imagePreview" style="width:120px; height:120px;" fit="cover" />
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="showAddDialog = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from "element-ui"
import { getProductList, addProduct, updateProduct, deleteProduct } from "@/api/product"

export default {
  name: "Product",
  data() {
    return {
      list: [],
      total: 0,
      page: 1,
      pageSize: 5,
      showAddDialog: false,
      form: {
        id: null,
        name: "",
        field: "",
        type: "",
        summary: "",
        description: "",
        imageFile: null,       // 上传的文件对象
        imagePreview: ""       // 预览图片
      }
    }
  },
  created() {
    this.loadProducts()
  },
  methods: {
    getFullImageUrl(imagePath) {
      return this.$serverUrl + imagePath;
    },

    async loadProducts() {
      try {
        const res = await getProductList({ page: this.page, pageSize: this.pageSize })
        if (res.data.status === 200) {
          this.list = res.data.data.list
          this.total = res.data.data.total
        } else {
          Message.error(res.data.msg || "获取产品列表失败")
        }
      } catch (error) {
        Message.error("请求异常")
      }
    },

    openAddDialog() {
      this.form = {
        id: null,
        name: "",
        field: "",
        type: "",
        summary: "",
        description: "",
        imageFile: null,
        imagePreview: ""
      }
      this.showAddDialog = true
    },

    edit(row) {
      this.form = {
        id: row.id,
        name: row.name,
        field: row.field,
        type: row.type,
        summary: row.summary,
        description: row.description,
        imageFile: null,
        imagePreview: this.getFullImageUrl(row.image)
      }
      this.showAddDialog = true
    },

    onFileChange(event) {
      const file = event.target.files[0]
      if (file) {
        this.form.imageFile = file
        this.form.imagePreview = URL.createObjectURL(file)
      }
    },

    async save() {
      try {
        const formData = new FormData()
        formData.append("name", this.form.name)
        formData.append("field", this.form.field)
        formData.append("type", this.form.type)
        formData.append("summary", this.form.summary)
        formData.append("description", this.form.description)
        if (this.form.imageFile) {
          formData.append("image", this.form.imageFile)
        }

        if (this.form.id) {
          formData.append("id", this.form.id)
          await updateProduct(formData)
          Message.success("修改成功")
        } else {
          await addProduct(formData)
          Message.success("新增成功")
        }
        this.showAddDialog = false
        this.loadProducts()
      } catch (error) {
        Message.error("操作失败")
      }
    },

    async remove(id) {
      try {
        await deleteProduct({ id })
        Message.success("删除成功")
        this.loadProducts()
      } catch (error) {
        Message.error("删除失败")
      }
    }
  }
}
</script>
